<template>
    <div class="timer-group-modal-container" @click.self="!isDeleting && $emit('close')" :class="{ 'is-deleting': isDeleting }">
        <div class="timer-group-modal" :class="[$mq]">
            <!-- Overlay de loading dentro del modal -->
            <!-- Para eliminar: solo Andy y loader (sin printer) -->
            <!-- Para imprimir: el componente padre activará el loader de impresión -->
            <!-- Nota: No hay loader para mover porque el componente padre cierra el modal inmediatamente -->
            <transition name="fade">
                <div v-if="isDeleting" id="loader-modal" ref="loader" :class="$mq">
                    <div id="content">
                        <div class="scheme">
                            <div class="andy"></div>
                            <div class="loader"></div>
                            <!-- NO mostrar printer cuando se elimina o mueve -->
                        </div>
                    </div>
                </div>
            </transition>
            <div class="timer-group-modal-header">
                <div class="text-title">{{ $t('timersproduct.group.product_selection') }}</div>
                <div class="close-button" @click="!isDeleting && $emit('close')" :class="{ 'disabled': isDeleting }">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M12 1.20857L10.7914 0L6 4.79143L1.20857 0L0 1.20857L4.79143 6L0 10.7914L1.20857 12L6 7.20857L10.7914 12L12 10.7914L7.20857 6L12 1.20857Z" fill="white" />
                    </svg>
                </div>
            </div>
            <div class="timer-group-modal-content">
                <!-- Columna Derecha: Opciones del timer -->
                <div class="left-column">
                    <!-- Placeholder cuando no hay timer seleccionado o cuando hay múltiples timers seleccionados -->
                    <div v-if="!selectedTimer || (isMultiSelectMode && selectedTimers.length > 1)" class="preview-placeholder">
                        <span>{{ previewPlaceholderText }}</span>
                    </div>

                    <div class="preview-section" v-if="selectedTimer && previewData && !(isMultiSelectMode && selectedTimers.length > 1)">
                        <div class="start-units" v-if="showQuantityInitial">
                            <div class="icon-units"></div>
                            <span class="number-units">{{ previewData.quantity }}</span>
                            <span class="text-units">{{ $t('timersproduct.units_starts') }}</span>
                        </div>

                        <div class="preview">
                            <div class="zpl-preview-wrapper">
                                <Preview
                                  v-if="!isZplPreview"
                                  :refresh="false"
                                  :key="selectedTimer.id"
                                  :calculate="previewKey"
                                  :data="previewData"
                                />

                                <ZplPreview
                                  v-else
                                  :data="zpl"
                                  :density="density"
                                  :width="labelWidth"
                                  :height="labelHeight"
                                  :values="zplValues"
                                  :params="zplParams"
                                  :showControls="false"
                                  :fitToContainer="true"
                                  :previewScale="2"
                                  :scale="1"
                                  :key="zplKey"
                                />
                            </div>
                            <div class="quantity">
                                <span>
                                    {{ $t('timersproduct.units_avaible') }}: <span class="units">{{ previewData.quantity_avaibles }}</span>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div v-if="hasSelection" class="actions-section">
                        <!-- Botón mover hacia atrás -->
                        <div v-if="previousMoveState && selectedTimers.length <= 1" class="button-with-controls" :class="{ 'is-deleting': isDeleting }">
                            <div
                                v-if="hasMultipleUnits"
                                class="control-button minus-button"
                                :class="{
                                    'minus-blue-active': canDecreaseMoveBack && !isDeleting,
                                    'minus-blue-inactive': !canDecreaseMoveBack || isDeleting
                                }"
                                @click="!isDeleting && decreaseCount('movedBackCount')"
                                :style="{ pointerEvents: isDeleting ? 'none' : 'auto', cursor: isDeleting ? 'not-allowed' : 'pointer' }"
                            ></div>
                            <Button
                                bType="move"
                                :bLabel="hasMultipleUnits ? $t('label.popup.move_timer_count', { c: movedBackCount, s: previousMoveState.name }) : $t('label.popup.move_timer', { s: previousMoveState.name })"
                                :customClass="['selector-popup', !canMoveBackTimer || isDeleting ? 'blocked' : '']"
                                :bCallback="() => !isDeleting && handleMoveTimer(previousMoveState.id, movedBackCount)"
                                :isLoading="isDeleting"
                                :style="{ width: hasMultipleUnits ? '80%' : '100%' }"
                            />
                            <div
                                v-if="hasMultipleUnits"
                                class="control-button plus-button"
                                :class="{
                                    'plus-blue-active': canIncreaseMoveBack && !isDeleting,
                                    'plus-blue-inactive': !canIncreaseMoveBack || isDeleting
                                }"
                                @click="!isDeleting && increaseCount('movedBackCount')"
                                :style="{ pointerEvents: isDeleting ? 'none' : 'auto', cursor: isDeleting ? 'not-allowed' : 'pointer' }"
                            ></div>
                        </div>

                        <!-- Botones mover hacia adelante -->
                        <template v-if="selectedTimers.length <= 1">
                            <div v-for="(moveState, index) in nextMoveStates" :key="moveState.id" class="button-with-controls" :class="{ 'is-deleting': isDeleting }">
                                <div
                                    v-if="hasMultipleUnits"
                                    class="control-button minus-button"
                                    :class="{
                                        'minus-blue-active': canDecreaseMove(index) && !isDeleting,
                                        'minus-blue-inactive': !canDecreaseMove(index) || isDeleting
                                    }"
                                    @click="!isDeleting && decreaseCount('movedCount', index)"
                                    :style="{ pointerEvents: isDeleting ? 'none' : 'auto', cursor: isDeleting ? 'not-allowed' : 'pointer' }"
                                ></div>
                                <Button
                                    bType="move"
                                    :bLabel="hasMultipleUnits ? $t('label.popup.move_timer_count', { c: movedCounts[index], s: moveState.name }) : $t('label.popup.move_timer', { s: moveState.name })"
                                    :customClass="['selector-popup', !canMoveTimer || isDeleting ? 'blocked' : '']"
                                    :bCallback="() => !isDeleting && handleMoveTimer(moveState.id, movedCounts[index], index)"
                                    :isLoading="isDeleting"
                                    :style="{ width: hasMultipleUnits ? '80%' : '100%' }"
                                />
                                <div
                                    v-if="hasMultipleUnits"
                                    class="control-button plus-button"
                                    :class="{
                                        'plus-blue-active': canIncreaseMove(index) && !isDeleting,
                                        'plus-blue-inactive': !canIncreaseMove(index) || isDeleting
                                    }"
                                    @click="!isDeleting && increaseCount('movedCount', index)"
                                    :style="{ pointerEvents: isDeleting ? 'none' : 'auto', cursor: isDeleting ? 'not-allowed' : 'pointer' }"
                                ></div>
                            </div>
                        </template>

                        <!-- Botón imprimir -->
                        <div v-if="canPrintTimer && statusPrinter && selectedTimers.length <= 1" class="button-with-controls" :class="{ 'is-deleting': isDeleting }">
                            <div
                                v-if="hasMultipleUnits"
                                class="control-button minus-button"
                                :class="{
                                    'minus-gray-active': printedCount > 1 && !isDeleting,
                                    'minus-gray-inactive': printedCount <= 1 || isDeleting
                                }"
                                @click="!isDeleting && decreaseCount('printedCount')"
                                :style="{ pointerEvents: isDeleting ? 'none' : 'auto', cursor: isDeleting ? 'not-allowed' : 'pointer' }"
                            ></div>
                            <Button
                                bType="print"
                                :bLabel="hasMultipleUnits ? $t('timersproduct.renew_printer_count', { c: printedCount }) : $t('timersproduct.renew_printer')"
                                :customClass="['selector-popup', isDeleting ? 'blocked' : '']"
                                :bCallback="() => !isDeleting && handlePrint()"
                                :isLoading="isDeleting"
                                :style="{ width: hasMultipleUnits ? '80%' : '100%' }"
                            />
                            <div
                                v-if="hasMultipleUnits"
                                class="control-button plus-button"
                                :class="{
                                    'plus-gray-active': canIncreasePrint && !isDeleting,
                                    'plus-gray-inactive': !canIncreasePrint || isDeleting
                                }"
                                @click="!isDeleting && increaseCount('printedCount')"
                                :style="{ pointerEvents: isDeleting ? 'none' : 'auto', cursor: isDeleting ? 'not-allowed' : 'pointer' }"
                            ></div>
                        </div>

                        <div v-if="canAddUnits" class="button-with-controls" :class="{ 'is-deleting': isDeleting }">
                            <div
                                class="control-button minus-button"
                                :class="{
                                    'minus-gray-active': canDecreaseAddUnitsModal && !isDeleting,
                                    'minus-gray-inactive': !canDecreaseAddUnitsModal || isDeleting
                                }"
                                @click="!isDeleting && decreaseAddUnitsCount()"
                                :style="{ pointerEvents: isDeleting ? 'none' : 'auto', cursor: isDeleting ? 'not-allowed' : 'pointer' }"
                            ></div>
                            <Button
                                bType="add-units"
                                :bLabel="addUnitsCount === 1 ? $t('timersproduct.add_units_button_unique') : $t('timersproduct.add_units_button', { c: addUnitsCount })"
                                :customClass="['selector-popup', isDeleting ? 'blocked' : '']"
                                :bCallback="() => !isDeleting && handleAddUnits()"
                                :isLoading="isDeleting"
                                :style="{ width: '80%' }"
                            >
                                <template #icon>
                                    <i class="i-andy-add i-andy-m btn-add-units__icon" aria-hidden="true"></i>
                                </template>
                            </Button>
                            <div
                                class="control-button plus-button"
                                :class="{
                                    'plus-gray-active': canIncreaseAddUnitsModal && !isDeleting,
                                    'plus-gray-inactive': !canIncreaseAddUnitsModal || isDeleting
                                }"
                                @click="!isDeleting && increaseAddUnitsCount()"
                                :style="{ pointerEvents: isDeleting ? 'none' : 'auto', cursor: isDeleting ? 'not-allowed' : 'pointer' }"
                            ></div>
                        </div>

                        <!-- Botón eliminar -->
                        <div class="button-with-controls" :class="{ 'is-deleting': isDeleting }">
                            <div
                                v-if="hasMultipleUnits"
                                class="control-button minus-button"
                                :class="{
                                    'minus-red-active': deletedCount > 1 && !isDeleting,
                                    'minus-red-inactive': deletedCount <= 1 || isDeleting
                                }"
                                @click="!isDeleting && decreaseCount('deletedCount')"
                                :style="{ pointerEvents: isDeleting ? 'none' : 'auto', cursor: isDeleting ? 'not-allowed' : 'pointer' }"
                            ></div>
                            <Button
                                bType="delete-timer"
                                :bLabel="hasMultipleUnits ? $t('label.popup.delete_timer_count', { c: deletedCount }) : $t('label.popup.delete_timer')"
                                :customClass="['selector-popup', isDeleting ? 'blocked' : '']"
                                :bCallback="handleDelete"
                                :isLoading="isDeleting"
                                :style="{ width: hasMultipleUnits ? '80%' : '100%' }"
                            />
                            <div
                                v-if="hasMultipleUnits"
                                class="control-button plus-button"
                                :class="{
                                    'plus-red-active': canIncreaseDelete && !isDeleting,
                                    'plus-red-inactive': !canIncreaseDelete || isDeleting
                                }"
                                @click="!isDeleting && increaseCount('deletedCount')"
                                :style="{ pointerEvents: isDeleting ? 'none' : 'auto', cursor: isDeleting ? 'not-allowed' : 'pointer' }"
                            ></div>
                        </div>
                    </div>
                </div>

                <!-- Columna Izquierda: Lista de timers del grupo -->
                <div class="right-column">
                    <div class="selection-header">
                        <span class="select-product-label">{{ $t('timersproduct.group.select_product') }}</span>
                        <span v-if="isMultiSelectMode && selectedCount > 0" class="selected-count">
                            {{ selectedCount }}
                        </span>
                    </div>

                    <TimerGroupModalCardsList
                        :group-timers="groupTimers"
                        :is-deleting="isDeleting"
                        :selected-timer-ids="selectedTimers.map((t) => t.id)"
                        @select="selectTimer"
                        @longpress="activateMultiSelect"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/domain/ui/Button.vue'
import Preview from '@/components/domain/label/preview.vue'
import ZplPreview from '@/components/domain/label/ZplPreview.vue'
import TimerGroupModalCardsList from '@/components/domain/timerproduct/TimerGroupModalCardsList.vue'
import { TIMERPRODUCT_STATUS } from '@/constants'
import { openModal, closeModal } from '@/core/modalManager'

export default {
    name: 'TimerGroupModal',
    components: { Button, Preview, ZplPreview, TimerGroupModalCardsList },
    props: {
        title: {
            type: String,
            default: ''
        },
        groupTimers: {
            type: Array,
            required: true,
            default: () => []
        },
        initialSelectedTimer: {
            type: Object,
            default: null
        },
        previewData: {
            type: Object,
            default: null
        },
        isZplPreview: {
            type: Boolean,
            default: false
        },
        zpl: {
            type: String,
            default: ''
        },
        density: {
            type: Number,
            default: 203
        },
        labelWidth: {
            type: Number,
            default: 55
        },
        labelHeight: {
            type: Number,
            default: 50
        },
        zplValues: {
            type: Object,
            default: () => ({})
        },
        zplParams: {
            type: Object,
            default: () => ({})
        },
        zplKey: {
            type: Number,
            default: 0
        },
        canMoveTimer: {
            type: Boolean,
            default: false
        },
        /** Retroceso a estado anterior (p. ej. PREPARATION): independiente de canMoveTimer */
        canMoveBackTimer: {
            type: Boolean,
            default: false
        },
        canPrintTimer: {
            type: Boolean,
            default: false
        },
        previousMoveState: {
            type: Object,
            default: null
        },
        nextMoveStates: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            selectedTimer: null,
            selectedTimers: [],
            isMultiSelectMode: false,
            previewKey: 0,
            movedBackCount: 1,
            movedCounts: [],
            printedCount: 1,
            deletedCount: 1,
            addUnitsCount: 1,
            isDeleting: false
        }
    },
    computed: {
        statusPrinter() {
            return this.$store.getters['printer/getStatusPrinter']
        },
        maxQuantity() {
            if (!this.previewData) return 1
            return this.previewData.quantity_avaibles || this.previewData.quantity || 1
        },
        hasMultipleUnits() {
            // En modo multiselección, no mostrar controles de cantidad
            if (this.isMultiSelectMode && this.selectedTimers.length > 1) return false
            return parseInt(this.maxQuantity) > 1
        },
        showQuantityInitial() {
            const quantity = this.previewData && this.previewData.quantity ? this.previewData.quantity : null
            return quantity && quantity !== '1' && quantity !== 1
        },
        canDecreaseMoveBack() {
            return this.movedBackCount > 1
        },
        canIncreaseMoveBack() {
            return this.movedBackCount < this.maxQuantity
        },
        canIncreasePrint() {
            return this.printedCount < this.maxQuantity
        },
        canIncreaseDelete() {
            return this.deletedCount < this.maxQuantity
        },
        canAddUnits() {
            if (!this.selectedTimer || !this.selectedTimer.data) {
                return false
            }
            if (this.isMultiSelectMode && this.selectedTimers.length > 1) {
                return false
            }
            if (!this.isTimerLive(this.selectedTimer)) {
                return false
            }
            const product = this.$store.getters['timerproduct/getProducts'](this.selectedTimer.reference_id)
            const refConfig = this.selectedTimer.reference_config || (product && product.reference_config)
            return !!(refConfig && refConfig.add_units === true)
        },
        canDecreaseAddUnitsModal() {
            return this.addUnitsCount > 1
        },
        canIncreaseAddUnitsModal() {
            return this.addUnitsCount < 99
        },
        hasSelection() {
            return this.selectedTimers.length > 0
        },
        selectedCount() {
            return this.selectedTimers.length
        },
        previewPlaceholderText() {
            // Si hay múltiples timers seleccionados, usar preview_not_available del backend o la traducción
            if (this.isMultiSelectMode && this.selectedTimers.length > 1) {
                // Priorizar el texto del backend si está disponible, sino usar la traducción
                if (this.previewData && this.previewData.preview_not_available) {
                    return this.previewData.preview_not_available
                }
                return this.$t('timersproduct.group.preview_not_available')
            }
            // Caso por defecto: cuando no hay timer seleccionado
            return this.$t('timersproduct.group.select_product_preview')
        }
    },
    methods: {
        selectTimer(timer) {
            // Si el modo multiselección está activo, toggle la selección
            if (this.isMultiSelectMode) {
                this.toggleTimerSelection(timer)
            } else {
                // Selección individual: seleccionar este timer y mostrar preview
                this.selectedTimer = timer
                this.selectedTimers = [timer]
                this.addUnitsCount = 1
                this.previewKey++
                this.$emit('timerSelected', timer)
            }
        },
        toggleTimerSelection(timer) {
            const index = this.selectedTimers.findIndex(t => t.id === timer.id)
            if (index > -1) {
                // Ya está seleccionado, quitarlo
                this.selectedTimers.splice(index, 1)

                // Verificar si solo queda 1 timer después de deseleccionar
                if (this.selectedTimers.length === 1) {
                    // Salir del modo multi-selección cuando solo queda 1 timer
                    this.isMultiSelectMode = false
                    this.addUnitsCount = 1
                    // Actualizar preview al timer restante
                    this.selectedTimer = this.selectedTimers[0]
                    this.previewKey++
                    this.$emit('timerSelected', this.selectedTimer)
                } else if (this.selectedTimers.length === 0) {
                    // No quedan timers seleccionados, salir del modo multi-selección
                    this.isMultiSelectMode = false
                    this.addUnitsCount = 1
                    this.selectedTimer = null
                } else {
                    // Si era el timer principal mostrado y aún hay más timers, actualizar preview
                    if (this.selectedTimer && this.selectedTimer.id === timer.id) {
                        this.selectedTimer = this.selectedTimers[0]
                        this.previewKey++
                        // Emitir evento con información de múltiples timers para evitar preparar preview individual
                        this.$emit('timerSelected', this.selectedTimer, { isMultiple: true, count: this.selectedTimers.length })
                    }
                }
            } else {
                // Añadir a la selección
                this.selectedTimers.push(timer)
                // En modo multi-selección, cambiar el preview y emitir evento para actualizar datos
                this.selectedTimer = timer
                this.previewKey++
                // Si hay más de un timer seleccionado, emitir evento con información de múltiples timers
                if (this.selectedTimers.length > 1) {
                    this.$emit('timerSelected', timer, { isMultiple: true, count: this.selectedTimers.length })
                } else {
                    this.$emit('timerSelected', timer)
                }
            }
        },
        activateMultiSelect(timer) {
            this.isMultiSelectMode = true
            // Resetear contadores cuando se entra en modo multi-selección
            this.movedBackCount = 1
            this.movedCounts = this.nextMoveStates.map(() => 1)
            this.printedCount = 1
            this.deletedCount = 1
            this.addUnitsCount = 1

            // Si no hay timers seleccionados, añadir el actual
            if (this.selectedTimers.length === 0 && timer) {
                this.selectedTimers = [timer]
                this.selectedTimer = timer
                this.previewKey++
                this.$emit('timerSelected', timer)
            } else if (!this.isTimerSelected(timer)) {
                // Si el timer no está seleccionado, añadirlo
                this.selectedTimers.push(timer)
            }
        },
        isTimerSelected(timer) {
            return this.selectedTimers.some(t => t.id === timer.id)
        },
        canDecreaseMove(index) {
            return this.movedCounts[index] > 1
        },
        canIncreaseMove(index) {
            return this.movedCounts[index] < this.maxQuantity
        },
        decreaseCount(type, index = null) {
            if (type === 'movedBackCount' && this.movedBackCount > 1) {
                this.movedBackCount--
            } else if (type === 'movedCount' && index !== null && this.movedCounts[index] > 1) {
                this.$set(this.movedCounts, index, this.movedCounts[index] - 1)
            } else if (type === 'printedCount' && this.printedCount > 1) {
                this.printedCount--
            } else if (type === 'deletedCount' && this.deletedCount > 1) {
                this.deletedCount--
            }
        },
        increaseCount(type, index = null) {
            const max = this.maxQuantity
            if (type === 'movedBackCount' && this.movedBackCount < max) {
                this.movedBackCount++
            } else if (type === 'movedCount' && index !== null && this.movedCounts[index] < max) {
                this.$set(this.movedCounts, index, this.movedCounts[index] + 1)
            } else if (type === 'printedCount' && this.printedCount < max) {
                this.printedCount++
            } else if (type === 'deletedCount' && this.deletedCount < max) {
                this.deletedCount++
            }
        },
        decreaseAddUnitsCount() {
            if (this.addUnitsCount > 1) {
                this.addUnitsCount--
            }
        },
        increaseAddUnitsCount() {
            if (this.addUnitsCount < 99) {
                this.addUnitsCount++
            }
        },
        handleAddUnits() {
            if (!this.selectedTimer || this.isDeleting) {
                return
            }
            if (this.isMultiSelectMode && this.selectedTimers.length > 1) {
                return
            }
            if (!this.isTimerLive(this.selectedTimer)) {
                return
            }
            this.$emit('addUnits', { timerId: this.selectedTimer.id, count: this.addUnitsCount })
        },
        handleMoveTimer(stateId, count, index = null) {
            if (this.selectedTimers.length === 0 || this.isDeleting) return

            const isBackwardMove = Boolean(this.previousMoveState && stateId === this.previousMoveState.id)
            if (isBackwardMove) {
                if (!this.canMoveBackTimer) return
            } else if (!this.canMoveTimer) {
                return
            }

            // Nota: No activamos loader aquí porque el componente padre cierra el modal inmediatamente
            // (ver handleGroupMoveTimer en TimerProduct.vue línea 3328)
            // El modal se destruye antes de que cualquier loader pueda mostrarse

            // Si hay múltiples timers seleccionados, emitir todos en un solo evento
            if (this.isMultiSelectMode && this.selectedTimers.length > 1) {
                this.$emit('moveTimer', {
                    timerIds: this.selectedTimers.map(t => t.id),
                    timers: this.selectedTimers,
                    nextState: stateId,
                    count: count,
                    index: index,
                    isMultiple: true,
                    isBackwardMove
                })
            } else {
                this.$emit('moveTimer', {
                    timerId: this.selectedTimer.id,
                    nextState: stateId,
                    count: count,
                    index: index,
                    isBackwardMove
                })
            }
        },
        handlePrint() {
            if (this.selectedTimers.length === 0 || this.isDeleting) return

            // NO activar el loader del modal para impresión - el componente padre activará el loader de impresión ($overlay.loading())
            // El loader del modal (isDeleting) es solo para eliminar

            // Si hay múltiples timers seleccionados, emitir todos en un solo evento
            if (this.isMultiSelectMode && this.selectedTimers.length > 1) {
                this.$emit('printTimer', {
                    timerIds: this.selectedTimers.map(t => t.id),
                    timers: this.selectedTimers,
                    count: this.printedCount,
                    isMultiple: true
                })
            } else {
                this.$emit('printTimer', {
                    timerId: this.selectedTimer.id,
                    count: this.printedCount
                })
            }
        },
        handleDelete() {
            if (this.selectedTimers.length === 0 || this.isDeleting) return

            // Activar overlay local del modal y deshabilitar controles ANTES de emitir el evento
            this.isDeleting = true

            // Crear el timeout ANTES del $emit para que el watcher pueda limpiarlo si se ejecuta sincrónicamente
            // Desactivar loader después de un tiempo razonable (el componente padre tarda ~800ms + tiempo de actualización)
            // El watcher de groupTimers también puede desactivarlo antes si detecta cambios
            // Usar un timeout más largo para asegurar que se vea el loader
            const timeoutId = setTimeout(() => {
                this.isDeleting = false
            }, 2500)

            // Guardar el timeoutId para poder limpiarlo si el watcher lo desactiva antes
            this._deleteTimeoutId = timeoutId

            // Guardar el count antes de resetear
            const countToDelete = this.deletedCount

            // Si hay múltiples timers seleccionados, emitir todos en un solo evento
            if (this.isMultiSelectMode && this.selectedTimers.length > 1) {
                this.$emit('deleteTimer', {
                    timerIds: this.selectedTimers.map(t => t.id),
                    timers: this.selectedTimers,
                    count: countToDelete,
                    isMultiple: true
                })
            } else {
                this.$emit('deleteTimer', {
                    timerId: this.selectedTimer.id,
                    count: countToDelete
                })
            }

            // Resetear el contador a 1 después de eliminar
            this.deletedCount = 1
        },
        isTimerLive(timer) {
            return timer.status !== TIMERPRODUCT_STATUS.EXPIRED
        }
    },
    created() {
        // Coordinar modal con modalManager
        openModal()

        // Inicializar con el timer seleccionado inicial si existe
        if (this.initialSelectedTimer) {
            this.selectedTimer = this.initialSelectedTimer
            this.selectedTimers = [this.initialSelectedTimer]
        } else {
            // No seleccionar ningún timer por defecto
            this.selectedTimer = null
            this.selectedTimers = []
        }
        this.isMultiSelectMode = false

        // Inicializar propiedades de timeout (no pueden estar en data() porque empiezan con _)
        // En Vue 2, las propiedades que empiezan con _ no son proxied
        this._deleteTimeoutId = null
        this._watcherDeleteTimeoutId = null
    },
    beforeDestroy() {
        // Coordinar modal con modalManager
        closeModal()

        // Limpiar timeouts principales si existen
        if (this._deleteTimeoutId) {
            clearTimeout(this._deleteTimeoutId)
            this._deleteTimeoutId = null
        }
        // Limpiar timeouts del watcher si existen
        if (this._watcherDeleteTimeoutId) {
            clearTimeout(this._watcherDeleteTimeoutId)
            this._watcherDeleteTimeoutId = null
        }
    },
    watch: {
        // Actualizar cuando cambian los timers del grupo
        groupTimers: {
            handler(newGroupTimers, oldGroupTimers) {

                if (!newGroupTimers) {
                    return
                }

                // Verificar si cambió la longitud
                const lengthChanged = newGroupTimers.length !== (oldGroupTimers ? oldGroupTimers.length : 0)

                // Verificar si cambiaron los IDs
                let idsChanged = false
                if (oldGroupTimers && oldGroupTimers.length > 0) {
                    const newIds = newGroupTimers.map(t => t && t.id).filter(Boolean).sort()
                    const oldIds = oldGroupTimers.map(t => t && t.id).filter(Boolean).sort()
                    idsChanged = JSON.stringify(newIds) !== JSON.stringify(oldIds)
                } else if (newGroupTimers.length > 0) {
                    // Si no había timers antes y ahora hay, es un cambio
                    idsChanged = true
                }

                // Verificar si cambiaron las cantidades disponibles de los timers existentes
                let quantitiesChanged = false
                if (oldGroupTimers && oldGroupTimers.length > 0 && newGroupTimers.length > 0) {
                    for (const newTimer of newGroupTimers) {
                        if (newTimer && newTimer.id) {
                            const oldTimer = oldGroupTimers.find(t => t && t.id === newTimer.id)
                            if (oldTimer) {
                                const newQuantity = Number(newTimer.data && newTimer.data.quantity_avaibles) || 0
                                const oldQuantity = Number(oldTimer.data && oldTimer.data.quantity_avaibles) || 0
                                if (newQuantity !== oldQuantity) {
                                    quantitiesChanged = true
                                    break
                                }
                            }
                        }
                    }
                }

                // Si hay cambios y estamos en modo de eliminación, desactivar el loader
                if (this.isDeleting && (lengthChanged || idsChanged || quantitiesChanged)) {
                    // Limpiar el timeout principal si existe
                    if (this._deleteTimeoutId) {
                        clearTimeout(this._deleteTimeoutId)
                        this._deleteTimeoutId = null
                    }
                    // Limpiar el timeout del watcher anterior si existe
                    if (this._watcherDeleteTimeoutId) {
                        clearTimeout(this._watcherDeleteTimeoutId)
                        this._watcherDeleteTimeoutId = null
                    }
                    // Esperar un momento para asegurar que los cambios se hayan propagado
                    this.$nextTick(() => {
                        // Rastrear el timeout del watcher para poder limpiarlo si el componente se destruye
                        this._watcherDeleteTimeoutId = setTimeout(() => {
                            this.isDeleting = false
                            this._watcherDeleteTimeoutId = null
                        }, 500)
                    })
                }


                // Vue debería detectar los cambios automáticamente gracias a la key dinámica del componente
                // y la key del v-for que incluye id, quantity_avaibles e index
                // Solo forzar actualización si realmente es necesario (cambios detectados)
                if (lengthChanged || idsChanged || quantitiesChanged) {
                    // Un solo $forceUpdate es suficiente si Vue no detecta el cambio automáticamente
                    this.$nextTick(() => {
                        this.$forceUpdate()
                    })
                }
            },
            deep: true,
            immediate: true
        },
        // Reinicializar movedCounts cuando cambian los nextMoveStates
        nextMoveStates: {
            handler(newStates) {
                this.movedCounts = newStates.map(() => 1)
            },
            immediate: true
        },
        // Actualizar selección cuando cambia el timer inicial
        // Solo resetear si realmente cambió el ID del timer (cambio externo)
        initialSelectedTimer: {
            handler(newTimer, oldTimer) {
                // Si newTimer es null, resetear la selección para mostrar el mensaje de seleccionar un timer
                if (!newTimer) {
                    this.selectedTimer = null
                    this.selectedTimers = []
                    this.isMultiSelectMode = false
                    this.previewKey++
                    return
                }

                // Si no hay timer anterior o el ID cambió, es un cambio externo real
                const isExternalChange = !oldTimer || (oldTimer.id !== newTimer.id)

                // Solo resetear si es un cambio externo y no estamos en modo multi-selección activo
                // o si el nuevo timer no está en nuestra selección actual
                if (isExternalChange) {
                    const isInCurrentSelection = this.selectedTimers.some(t => t.id === newTimer.id)

                    // Si estamos en modo multi-selección y el nuevo timer está en nuestra selección,
                    // solo actualizar el preview sin resetear
                    if (this.isMultiSelectMode && isInCurrentSelection) {
                        this.selectedTimer = newTimer
                        this.previewKey++
                        return
                    }

                    // Resetear completamente solo cuando es un cambio externo real
                    this.selectedTimer = newTimer
                    this.selectedTimers = [newTimer]
                    this.isMultiSelectMode = false
                }
            },
            immediate: true
        }
    },
}
</script>

<style lang="scss" scoped>
.timer-group-modal-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    @include display-flex();
    @include justify-content(center);
    @include align-items(center);
    overflow-y: auto;
    /* z-index extremadamente alto para asegurar que esté por encima de #menu-top */
    z-index: 999999;
}

.timer-group-modal {
    background-color: $color-white;
    border-radius: 6px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    width: 95%;
    max-width: 900px;
    max-height: 90vh;
    margin-left: auto;
    margin-right: auto;
    @include display-flex();
    @include flex-direction(column);
    overflow: hidden;
    position: relative;
    flex-shrink: 0;
    // Asegurar que el overlay pueda cubrir todo el contenido
    min-height: 0;

    &.portrait {
        max-width: 100%;
        max-height: 95vh;

        .timer-group-modal-content {
            @include flex-direction(column);

            .left-column,
            .right-column {
                width: 100%;
                max-height: 45vh;
            }
        }
    }
}

.timer-group-modal-header {
    padding: 1rem;
    border-bottom: 1px solid $color-white;
    @include display-flex();
    @include justify-content(space-between);
    @include align-items(center);
    background-color: $color-primary-500;
    color: $color-white;
    font-family: $text-bold;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    @include flex-shrink(0);
    position: relative;
    z-index: 1;

    .close-button.disabled {
        opacity: 0.5;
        cursor: not-allowed !important;
        pointer-events: none !important;
    }

    .text-title {
        font-size: 20px;
        color: $color-white;
        font-family: $text-bold;
    }
}

// Cuando hay overlay activo, reducir opacidad del header para que se vea que está bloqueado
.timer-group-modal:has(#loader-modal) .timer-group-modal-header {
    opacity: 0.7;
}

.close-button {
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    transition: background-color 0.2s;

    &:hover:not(.disabled) {
        background-color: rgba(255, 255, 255, 0.2);
    }
}

.timer-group-modal-content {
    @include display-flex();
    @include flex-direction(row);
    @include flex-grow(1);
    overflow-y: scroll; // Reservar espacio de scrollbar para evitar oscilación de ancho
    overflow-x: hidden;
    min-height: 0;
    position: relative;
    z-index: 1;
}

.left-column {
    width: 45%;
    padding: 16px 24px 8px 24px; // Reducir padding-bottom cuando tiene acciones
    @include display-flex();
    @include flex-direction(column);
    overflow-y: scroll;
    @include flex-order(2); // Mover a la derecha visualmente

    .preview-placeholder {
        @include display-flex();
        width: 100%;
        height: 312px;
        padding: 8px;
        @include flex-direction(column);
        @include justify-content(center);
        @include align-items(center);
        gap: 16px;
        border-radius: 5px;
        border: 1px solid $color-neutral-300;
        background: $color-white;
        margin-top: 40px; // Alinear con el contenedor de timers

        span {
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            color: $color-black;
            text-align: center;
        }
    }

    .preview-section {
        margin-bottom: 16px;

        .start-units {
            @include display-flex();
            padding: 8px;
            @include justify-content(center);
            @include align-items(center);
            gap: 8px;
            border-radius: 4px;
            border: 1px solid $color-neutral-400;
            background: $color-white;
            box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.06);
            margin-bottom: 12px;
            width: fit-content;
            margin-left: auto;
        }

        .icon-units {
            width: 13px;
            height: 13px;
            background-image: img('package_black.svg');
            background-size: 12px;
            background-repeat: no-repeat;
            background-position: center;
        }

        .number-units {
            font-family: $text-bold;
            font-size: 16px;
            color: $neutro-s90;
        }

        .text-units {
            font-size: 16px;
            color: $neutro-s90;
        }

        .preview {
            margin: 0;

            .zpl-preview-wrapper {
                width: 100%;
                min-height: 0;
                overflow: hidden;
            }

            .quantity {
                margin-top: 8px;
                text-align: right;
                font-size: 14px;

                .units {
                    font-weight: 700;
                }
            }
        }
    }

    .actions-section {
        @include display-flex();
        @include flex-direction(column);
        position: relative;
        z-index: 1; // Asegurar que esté por debajo del overlay
        gap: 0; // Sin espacio entre botones de acciones
    }
}

.right-column {
    width: 55%;
    @include display-flex();
    @include flex-direction(column);
    background-color: $color-white;
    overflow: hidden;
    @include flex-order(1); // Mover a la izquierda visualmente
    padding: 16px;

    .selection-header {
        @include display-flex();
        @include justify-content(space-between);
        @include align-items(center);
        margin-bottom: 16px;
    }

    .select-product-label {
        font-family: $text;
        font-size: 16px;
        color: $neutro-s90;
    }

    .selected-count {
        font-family: $text-bold;
        font-size: 14px;
        color: $color-info-500;
        background-color: rgba($color-info-500, 0.1);
        padding: 4px 12px;
        border-radius: 16px;
    }
}

// Estilos para botones de control (+/-)
.button-with-controls {
    @include display-flex();
    @include align-items(center);
    width: 100%;
    position: relative;
    z-index: 1; // Asegurar que esté por debajo del overlay
    gap: 8px;

    &.is-deleting {
        opacity: 0.7;

        .control-button {
            pointer-events: none !important;
            cursor: not-allowed !important;
        }
    }

    .control-button {
        width: 48px !important;
        height: 48px !important;
        min-width: 48px;
        @include display-flex();
        @include align-items(center);
        @include justify-content(center);
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s ease;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 16px;

        &[aria-disabled='true'] {
            cursor: not-allowed;
            opacity: 0.5;
        }
    }

    .minus-button {
        &.minus-blue-active {
            position: relative;
            background-color: $color-white;
            border: 1px solid $main-text;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $main-text;
                -webkit-mask: img('less_light.svg') no-repeat center;
                mask: img('less_light.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }

        &.minus-blue-inactive {
            position: relative;
            background-color: $color-white;
            border: 1px solid $main-text;
            opacity: 0.25;
            pointer-events: none !important;
            cursor: not-allowed !important;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $main-text;
                opacity: 0.45;
                -webkit-mask: img('less_light.svg') no-repeat center;
                mask: img('less_light.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }

        &.minus-gray-active {
            position: relative;
            background-color: $color-white;
            border: 1px solid $color-black;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $color-black;
                -webkit-mask: img('less_light.svg') no-repeat center;
                mask: img('less_light.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }

        &.minus-gray-inactive {
            position: relative;
            background-color: $color-white;
            border: 1px solid $color-black;
            opacity: 0.25;
            pointer-events: none !important;
            cursor: not-allowed !important;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $color-black;
                opacity: 0.45;
                -webkit-mask: img('less_light.svg') no-repeat center;
                mask: img('less_light.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }

        &.minus-red-active {
            position: relative;
            background-color: $color-white;
            border: 1px solid $color-error-500;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $color-error-500;
                -webkit-mask: img('less_light.svg') no-repeat center;
                mask: img('less_light.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }

        &.minus-red-inactive {
            position: relative;
            background-color: $color-white;
            border: 1px solid $color-error-500;
            opacity: 0.25;
            pointer-events: none !important;
            cursor: not-allowed !important;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                opacity: 0.45;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $color-error-500;
                -webkit-mask: img('less_light.svg') no-repeat center;
                mask: img('less_light.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }
    }

    .plus-button {
        &.plus-blue-active {
            position: relative;
            background-color: $color-white;
            border: 1px solid $main-text;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $main-text;
                -webkit-mask: img('more_ffffff.svg') no-repeat center;
                mask: img('more_ffffff.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }

        &.plus-blue-inactive {
            position: relative;
            background-color: $color-white;
            border: 1px solid $main-text;
            opacity: 0.25;
            pointer-events: none !important;
            cursor: not-allowed !important;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $main-text;
                opacity: 0.45;
                -webkit-mask: img('more_ffffff.svg') no-repeat center;
                mask: img('more_ffffff.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }

        &.plus-gray-active {
            position: relative;
            background-color: $color-white;
            border: 1px solid $color-black;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $color-black;
                -webkit-mask: img('more_ffffff.svg') no-repeat center;
                mask: img('more_ffffff.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }

        &.plus-gray-inactive {
            position: relative;
            background-color: $color-white;
            border: 1px solid $color-black;
            opacity: 0.25;
            pointer-events: none !important;
            cursor: not-allowed !important;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                opacity: 0.45;
                background-color: $color-black;
                -webkit-mask: img('more_ffffff.svg') no-repeat center;
                mask: img('more_ffffff.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }

        &.plus-red-active {
            position: relative;
            background-color: $color-white;
            border: 1px solid $color-error-500;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $color-error-500;
                -webkit-mask: img('more_ffffff.svg') no-repeat center;
                mask: img('more_ffffff.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }

        &.plus-red-inactive {
            position: relative;
            background-color: $color-white;
            border: 1px solid $color-error-500;
            opacity: 0.25;
            pointer-events: none !important;
            cursor: not-allowed !important;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $color-error-500;
                opacity: 0.45;
                -webkit-mask: img('more_ffffff.svg') no-repeat center;
                mask: img('more_ffffff.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }
    }
}
</style>

// Transición para el overlay (debe estar al nivel superior, no anidada)
<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>

// Loader dentro del modal (igual que #loader del sistema pero solo dentro del modal)
// Replica EXACTAMENTE el diseño de $loader.loading() - copiado del componente loader.vue línea por línea
// Estilos SIN scoped para que se apliquen correctamente (igual que el loader original)
<style lang="scss">
#loader-modal {
    background-color: #f4f2ed;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999999 !important; // Más alto que cualquier elemento dentro del modal
    border-radius: 6px;

    #content {
        @include display-flex();
        @include flex-direction(column);
        @include justify-content(center);
        @include align-items();
        height: 100%;
        padding: 0 30px;
        max-width: 600px;
        margin: 0 auto;

        .scheme {
            @include display-flex();
            @include justify-content(center);
            @include align-items();
            width: 100%;
            height: auto;
            padding-bottom: 50px;

            .andy,
            .loader {
                height: 80px;
                width: 80px;
                margin: 0 10px;
            }
            .andy {
                @include font-size(s);
                @include background($image: img('alex_carita_10.svg'), $size: 80px);
            }
            .loader {
                width: 100px;
                @include background($image: img('loader_main.svg'), $size: 80px);
            }
        }
    }

    // Estilos para modo portrait (igual que el loader del sistema)
    &.portrait {
        #content {
            .scheme {
                .andy,
                .loader {
                    height: 50px;
                    width: 50px;
                    background-size: 50px;
                }
                .loader {
                    width: 60px;
                }
            }
        }
    }
}
</style>
